// Generated code: do not modify this file as it will be overwritten
// Template: RecordReviver.cst

/* eslint-disable import/order */
import { Record, Map, List, Collection } from 'immutable';
import { ActivationRuleRecord } from './activation-rule-record.generated';
import { ActiveAlertAcknowledgementRecord } from './active-alert-acknowledgement-record.generated';
import { ActiveAlertRecord } from './active-alert-record.generated';
import { ActiveTimelineRecord } from './active-timeline-record.generated';
import { AlertRecord } from './alert-record.generated';
import { ApplicationNotificationRecord } from './application-notification-record.generated';
import { AssignmentDelayedReasonRecord } from './assignment-delayed-reason-record.generated';
import { CancellationCategoryRecord } from './cancellation-category-record.generated';
import { CancellationReasonRecord } from './cancellation-reason-record.generated';
import { CancellationSecondaryReasonRecord } from './cancellation-secondary-reason-record.generated';
import { CardRecord } from './card-record.generated';
import { CardLinkRecord } from './card-link-record.generated';
import { CardNoteArchiveRecord } from './card-note-archive-record.generated';
import { CardNoteRecord } from './card-note-record.generated';
import { CardReOpenReasonRecord } from './card-re-open-reason-record.generated';
import { CardSummaryRecord } from './card-summary-record.generated';
import { ConfigurationSettingRecord } from './configuration-setting-record.generated';
import { ConversationRecord } from './conversation-record.generated';
import { ConversationParticipantRecord } from './conversation-participant-record.generated';
import { DeclineCategoryRecord } from './decline-category-record.generated';
import { DeclineReasonRecord } from './decline-reason-record.generated';
import { DeclineSecondaryReasonRecord } from './decline-secondary-reason-record.generated';
import { DiversionReasonRecord } from './diversion-reason-record.generated';
import { EscortRequestRecord } from './escort-request-record.generated';
import { EstimatedDurationRecord } from './estimated-duration-record.generated';
import { EtaRecord } from './eta-record.generated';
import { ExternalActionRecord } from './external-action-record.generated';
import { ExternalActionTypeRecord } from './external-action-type-record.generated';
import { ExternalSystemUnitRecord } from './external-system-unit-record.generated';
import { FacilityNonAcceptanceReasonRecord } from './facility-non-acceptance-reason-record.generated';
import { FirewallRuleRecord } from './firewall-rule-record.generated';
import { FlightFollowingReportRecord } from './flight-following-report-record.generated';
import { LandingZoneOutOfServiceReasonRecord } from './landing-zone-out-of-service-reason-record.generated';
import { LocationHazardAttachmentRecord } from './location-hazard-attachment-record.generated';
import { LocationHazardRecord } from './location-hazard-record.generated';
import { ManifestEntryRecord } from './manifest-entry-record.generated';
import { MedicalControlContactLogEntryRecord } from './medical-control-contact-log-entry-record.generated';
import { MessageStatusUpdateRecord } from './message-status-update-record.generated';
import { NewAgencyLocationRequestRecord } from './new-agency-location-request-record.generated';
import { NextDueTypeRecord } from './next-due-type-record.generated';
import { NonReferralReasonRecord } from './non-referral-reason-record.generated';
import { NotificationRecord } from './notification-record.generated';
import { NotificationGroupRecord } from './notification-group-record.generated';
import { NotificationGroupMemberRecord } from './notification-group-member-record.generated';
import { NotificationRecipientRecord } from './notification-recipient-record.generated';
import { NotificationSubscriptionRecord } from './notification-subscription-record.generated';
import { NotificationTemplateRecord } from './notification-template-record.generated';
import { OemActivityRecord } from './oem-activity-record.generated';
import { OemAssetRecord } from './oem-asset-record.generated';
import { OemPlanChangeRequestRecord } from './oem-plan-change-request-record.generated';
import { OemPlanRecord } from './oem-plan-record.generated';
import { OfferAlgorithmRecord } from './offer-algorithm-record.generated';
import { OperationRecord } from './operation-record.generated';
import { OutOfServiceEventRecord } from './out-of-service-event-record.generated';
import { OutOfServiceEventNoteRecord } from './out-of-service-event-note-record.generated';
import { OutOfServiceReasonRecord } from './out-of-service-reason-record.generated';
import { OutOfServiceSecondaryReasonRecord } from './out-of-service-secondary-reason-record.generated';
import { OutOfServiceTicketRecord } from './out-of-service-ticket-record.generated';
import { PaipEventRecord } from './paip-event-record.generated';
import { PaipReasonRecord } from './paip-reason-record.generated';
import { PassdownLogAcknowledgementRecord } from './passdown-log-acknowledgement-record.generated';
import { PassdownLogArchivedLogRecord } from './passdown-log-archived-log-record.generated';
import { PassdownLogRecord } from './passdown-log-record.generated';
import { PatientRecord } from './patient-record.generated';
import { PositionReportAlertRecord } from './position-report-alert-record.generated';
import { PositionReportArchiveRecord } from './position-report-archive-record.generated';
import { PositionReportRecord } from './position-report-record.generated';
import { QuestionChoiceRecord } from './question-choice-record.generated';
import { QuestionRecord } from './question-record.generated';
import { QuestionnaireRecord } from './questionnaire-record.generated';
import { QuestionnaireQuestionResponseRecord } from './questionnaire-question-response-record.generated';
import { QuestionnaireQuestionResponseNoteRecord } from './questionnaire-question-response-note-record.generated';
import { QuestionnaireResponseRecord } from './questionnaire-response-record.generated';
import { QuestionnaireSectionRecord } from './questionnaire-section-record.generated';
import { QuestionnaireSectionQuestionRecord } from './questionnaire-section-question-record.generated';
import { ReceivingFacilityRequestRecord } from './receiving-facility-request-record.generated';
import { RendezvousRequestRecord } from './rendezvous-request-record.generated';
import { RequestRecord } from './request-record.generated';
import { RequesterRecord } from './requester-record.generated';
import { RequesterReferralReasonRecord } from './requester-referral-reason-record.generated';
import { RequesterRoleRecord } from './requester-role-record.generated';
import { RequestLocationRecord } from './request-location-record.generated';
import { RequestPatientRecord } from './request-patient-record.generated';
import { SystemTimerRecord } from './system-timer-record.generated';
import { TimelineRecord } from './timeline-record.generated';
import { TimelineItemRecord } from './timeline-item-record.generated';
import { TimestampRecord } from './timestamp-record.generated';
import { TimestampTypeRecord } from './timestamp-type-record.generated';
import { TrackedMessageRecord } from './tracked-message-record.generated';
import { TransferReasonRecord } from './transfer-reason-record.generated';
import { TransportOfferRecord } from './transport-offer-record.generated';
import { TransportOfferOptionRecord } from './transport-offer-option-record.generated';
import { TransportReasonRecord } from './transport-reason-record.generated';
import { TripRecord } from './trip-record.generated';
import { TripLegRecord } from './trip-leg-record.generated';
import { TripPassengerRecord } from './trip-passenger-record.generated';
import { UnitActivationRuleRecord } from './unit-activation-rule-record.generated';
import { UnitEMSystemMappingRecord } from './unit-em-system-mapping-record.generated';
import { UnitRecord } from './unit-record.generated';
import { UnitNoteRecord } from './unit-note-record.generated';
import { UnitPositionRecord } from './unit-position-record.generated';
import { UnitShiftRecord } from './unit-shift-record.generated';
import { UnitStatusHistoryEntryRecord } from './unit-status-history-entry-record.generated';
import { UnitSummaryRecord } from './unit-summary-record.generated';
import { VehicleDispositionRecord } from './vehicle-disposition-record.generated';
import { VehicleNotificationGroupRecord } from './vehicle-notification-group-record.generated';
import { VehicleSummaryRecord } from './vehicle-summary-record.generated';
import { WaypointRecord } from './waypoint-record.generated';
import { WebOrderLogRecord } from './web-order-log-record.generated';
import { AccessibleItemRecord } from './accessible-item-record.generated';
import { AgencyRecord } from './agency-record.generated';
import { AgencyLocationRecord } from './agency-location-record.generated';
import { AirportRecord } from './airport-record.generated';
import { ArchiveLogRecord } from './archive-log-record.generated';
import { AttachmentRecord } from './attachment-record.generated';
import { BaseControlZoneRecord } from './base-control-zone-record.generated';
import { BaseRecord } from './base-record.generated';
import { BaseMedicalControlContactRecord } from './base-medical-control-contact-record.generated';
import { BaseMedicalControlContactStateRecord } from './base-medical-control-contact-state-record.generated';
import { CapabilityRecord } from './capability-record.generated';
import { CommunicationCenterRecord } from './communication-center-record.generated';
import { CommunicationCenterTransportOfferOptionRecord } from './communication-center-transport-offer-option-record.generated';
import { CompanyRecord } from './company-record.generated';
import { CompleteFlightInstanceRecord } from './complete-flight-instance-record.generated';
import { ControlZoneRecord } from './control-zone-record.generated';
import { DepartmentRecord } from './department-record.generated';
import { EntityCapabilityRecord } from './entity-capability-record.generated';
import { ExternalReferenceRecord } from './external-reference-record.generated';
import { FboRecord } from './fbo-record.generated';
import { FuelTankRecord } from './fuel-tank-record.generated';
import { LocationRecord } from './location-record.generated';
import { MaintenanceFacilityRecord } from './maintenance-facility-record.generated';
import { MedicalFacilityContactRecord } from './medical-facility-contact-record.generated';
import { MedicalFacilityRecord } from './medical-facility-record.generated';
import { MedicalFacilityPhysicianRecord } from './medical-facility-physician-record.generated';
import { MedicalFacilityUnitRecord } from './medical-facility-unit-record.generated';
import { MedicalUnitRecord } from './medical-unit-record.generated';
import { OutOfServiceQARReasonRecord } from './out-of-service-qar-reason-record.generated';
import { PersonRecord } from './person-record.generated';
import { PhysicianRecord } from './physician-record.generated';
import { ProgramBaseRecord } from './program-base-record.generated';
import { ProgramRecord } from './program-record.generated';
import { RamcoVehicleConfigurationRecord } from './ramco-vehicle-configuration-record.generated';
import { RegionBaseRecord } from './region-base-record.generated';
import { RegionRecord } from './region-record.generated';
import { RegionGroupRecord } from './region-group-record.generated';
import { ReleaseNoteRecord } from './release-note-record.generated';
import { SpecialtyTeamRecord } from './specialty-team-record.generated';
import { SpecialtyTeamMemberRecord } from './specialty-team-member-record.generated';
import { StateRecord } from './state-record.generated';
import { SupportRequestRecord } from './support-request-record.generated';
import { TimezoneRecord } from './timezone-record.generated';
import { TransferCenterRecord } from './transfer-center-record.generated';
import { TrmUserAgencyRecord } from './trm-user-agency-record.generated';
import { TrmUserRecord } from './trm-user-record.generated';
import { TrmUserMedicalFacilityRecord } from './trm-user-medical-facility-record.generated';
import { TrmUserProgramRecord } from './trm-user-program-record.generated';
import { VehicleControlZoneRecord } from './vehicle-control-zone-record.generated';
import { VehicleRecord } from './vehicle-record.generated';
import { VehicleMaintenanceRecord } from './vehicle-maintenance-record.generated';
import { VehicleMakeRecord } from './vehicle-make-record.generated';
import { VehicleModelRecord } from './vehicle-model-record.generated';
import { VehicleStateInspectionRecord } from './vehicle-state-inspection-record.generated';
import { ActiveCardUnitOfferingRecord } from './active-card-unit-offering-record.generated';
import { VehiclePositionSummaryRecord } from './vehicle-position-summary-record.generated';
import { TcsEntityRecord } from './client-sync.generated';

export function revive({ state, type }: { state: any; type: string }): TcsEntityRecord | undefined {
  switch (type) {
    case 'ActivationRule': {
      return ActivationRuleRecord.fromJS(state);
    }
    case 'ActiveAlertAcknowledgement': {
      return ActiveAlertAcknowledgementRecord.fromJS(state);
    }
    case 'ActiveAlert': {
      return ActiveAlertRecord.fromJS(state);
    }
    case 'ActiveTimeline': {
      return ActiveTimelineRecord.fromJS(state);
    }
    case 'Alert': {
      return AlertRecord.fromJS(state);
    }
    case 'ApplicationNotification': {
      return ApplicationNotificationRecord.fromJS(state);
    }
    case 'AssignmentDelayedReason': {
      return AssignmentDelayedReasonRecord.fromJS(state);
    }
    case 'CancellationCategory': {
      return CancellationCategoryRecord.fromJS(state);
    }
    case 'CancellationReason': {
      return CancellationReasonRecord.fromJS(state);
    }
    case 'CancellationSecondaryReason': {
      return CancellationSecondaryReasonRecord.fromJS(state);
    }
    case 'Card': {
      return CardRecord.fromJS(state);
    }
    case 'CardLink': {
      return CardLinkRecord.fromJS(state);
    }
    case 'CardNoteArchive': {
      return CardNoteArchiveRecord.fromJS(state);
    }
    case 'CardNote': {
      return CardNoteRecord.fromJS(state);
    }
    case 'CardReOpenReason': {
      return CardReOpenReasonRecord.fromJS(state);
    }
    case 'CardSummary': {
      return CardSummaryRecord.fromJS(state);
    }
    case 'ConfigurationSetting': {
      return ConfigurationSettingRecord.fromJS(state);
    }
    case 'Conversation': {
      return ConversationRecord.fromJS(state);
    }
    case 'ConversationParticipant': {
      return ConversationParticipantRecord.fromJS(state);
    }
    case 'DeclineCategory': {
      return DeclineCategoryRecord.fromJS(state);
    }
    case 'DeclineReason': {
      return DeclineReasonRecord.fromJS(state);
    }
    case 'DeclineSecondaryReason': {
      return DeclineSecondaryReasonRecord.fromJS(state);
    }
    case 'DiversionReason': {
      return DiversionReasonRecord.fromJS(state);
    }
    case 'EscortRequest': {
      return EscortRequestRecord.fromJS(state);
    }
    case 'EstimatedDuration': {
      return EstimatedDurationRecord.fromJS(state);
    }
    case 'Eta': {
      return EtaRecord.fromJS(state);
    }
    case 'ExternalAction': {
      return ExternalActionRecord.fromJS(state);
    }
    case 'ExternalActionType': {
      return ExternalActionTypeRecord.fromJS(state);
    }
    case 'ExternalSystemUnit': {
      return ExternalSystemUnitRecord.fromJS(state);
    }
    case 'FacilityNonAcceptanceReason': {
      return FacilityNonAcceptanceReasonRecord.fromJS(state);
    }
    case 'FirewallRule': {
      return FirewallRuleRecord.fromJS(state);
    }
    case 'FlightFollowingReport': {
      return FlightFollowingReportRecord.fromJS(state);
    }
    case 'LandingZoneOutOfServiceReason': {
      return LandingZoneOutOfServiceReasonRecord.fromJS(state);
    }
    case 'LocationHazardAttachment': {
      return LocationHazardAttachmentRecord.fromJS(state);
    }
    case 'LocationHazard': {
      return LocationHazardRecord.fromJS(state);
    }
    case 'ManifestEntry': {
      return ManifestEntryRecord.fromJS(state);
    }
    case 'MedicalControlContactLogEntry': {
      return MedicalControlContactLogEntryRecord.fromJS(state);
    }
    case 'MessageStatusUpdate': {
      return MessageStatusUpdateRecord.fromJS(state);
    }
    case 'NewAgencyLocationRequest': {
      return NewAgencyLocationRequestRecord.fromJS(state);
    }
    case 'NextDueType': {
      return NextDueTypeRecord.fromJS(state);
    }
    case 'NonReferralReason': {
      return NonReferralReasonRecord.fromJS(state);
    }
    case 'Notification': {
      return NotificationRecord.fromJS(state);
    }
    case 'NotificationGroup': {
      return NotificationGroupRecord.fromJS(state);
    }
    case 'NotificationGroupMember': {
      return NotificationGroupMemberRecord.fromJS(state);
    }
    case 'NotificationRecipient': {
      return NotificationRecipientRecord.fromJS(state);
    }
    case 'NotificationSubscription': {
      return NotificationSubscriptionRecord.fromJS(state);
    }
    case 'NotificationTemplate': {
      return NotificationTemplateRecord.fromJS(state);
    }
    case 'OemActivity': {
      return OemActivityRecord.fromJS(state);
    }
    case 'OemAsset': {
      return OemAssetRecord.fromJS(state);
    }
    case 'OemPlanChangeRequest': {
      return OemPlanChangeRequestRecord.fromJS(state);
    }
    case 'OemPlan': {
      return OemPlanRecord.fromJS(state);
    }
    case 'OfferAlgorithm': {
      return OfferAlgorithmRecord.fromJS(state);
    }
    case 'Operation': {
      return OperationRecord.fromJS(state);
    }
    case 'OutOfServiceEvent': {
      return OutOfServiceEventRecord.fromJS(state);
    }
    case 'OutOfServiceEventNote': {
      return OutOfServiceEventNoteRecord.fromJS(state);
    }
    case 'OutOfServiceReason': {
      return OutOfServiceReasonRecord.fromJS(state);
    }
    case 'OutOfServiceSecondaryReason': {
      return OutOfServiceSecondaryReasonRecord.fromJS(state);
    }
    case 'OutOfServiceTicket': {
      return OutOfServiceTicketRecord.fromJS(state);
    }
    case 'PaipEvent': {
      return PaipEventRecord.fromJS(state);
    }
    case 'PaipReason': {
      return PaipReasonRecord.fromJS(state);
    }
    case 'PassdownLogAcknowledgement': {
      return PassdownLogAcknowledgementRecord.fromJS(state);
    }
    case 'PassdownLogArchivedLog': {
      return PassdownLogArchivedLogRecord.fromJS(state);
    }
    case 'PassdownLog': {
      return PassdownLogRecord.fromJS(state);
    }
    case 'Patient': {
      return PatientRecord.fromJS(state);
    }
    case 'PositionReportAlert': {
      return PositionReportAlertRecord.fromJS(state);
    }
    case 'PositionReportArchive': {
      return PositionReportArchiveRecord.fromJS(state);
    }
    case 'PositionReport': {
      return PositionReportRecord.fromJS(state);
    }
    case 'QuestionChoice': {
      return QuestionChoiceRecord.fromJS(state);
    }
    case 'Question': {
      return QuestionRecord.fromJS(state);
    }
    case 'Questionnaire': {
      return QuestionnaireRecord.fromJS(state);
    }
    case 'QuestionnaireQuestionResponse': {
      return QuestionnaireQuestionResponseRecord.fromJS(state);
    }
    case 'QuestionnaireQuestionResponseNote': {
      return QuestionnaireQuestionResponseNoteRecord.fromJS(state);
    }
    case 'QuestionnaireResponse': {
      return QuestionnaireResponseRecord.fromJS(state);
    }
    case 'QuestionnaireSection': {
      return QuestionnaireSectionRecord.fromJS(state);
    }
    case 'QuestionnaireSectionQuestion': {
      return QuestionnaireSectionQuestionRecord.fromJS(state);
    }
    case 'ReceivingFacilityRequest': {
      return ReceivingFacilityRequestRecord.fromJS(state);
    }
    case 'RendezvousRequest': {
      return RendezvousRequestRecord.fromJS(state);
    }
    case 'Request': {
      return RequestRecord.fromJS(state);
    }
    case 'Requester': {
      return RequesterRecord.fromJS(state);
    }
    case 'RequesterReferralReason': {
      return RequesterReferralReasonRecord.fromJS(state);
    }
    case 'RequesterRole': {
      return RequesterRoleRecord.fromJS(state);
    }
    case 'RequestLocation': {
      return RequestLocationRecord.fromJS(state);
    }
    case 'RequestPatient': {
      return RequestPatientRecord.fromJS(state);
    }
    case 'SystemTimer': {
      return SystemTimerRecord.fromJS(state);
    }
    case 'Timeline': {
      return TimelineRecord.fromJS(state);
    }
    case 'TimelineItem': {
      return TimelineItemRecord.fromJS(state);
    }
    case 'Timestamp': {
      return TimestampRecord.fromJS(state);
    }
    case 'TimestampType': {
      return TimestampTypeRecord.fromJS(state);
    }
    case 'TrackedMessage': {
      return TrackedMessageRecord.fromJS(state);
    }
    case 'TransferReason': {
      return TransferReasonRecord.fromJS(state);
    }
    case 'TransportOffer': {
      return TransportOfferRecord.fromJS(state);
    }
    case 'TransportOfferOption': {
      return TransportOfferOptionRecord.fromJS(state);
    }
    case 'TransportReason': {
      return TransportReasonRecord.fromJS(state);
    }
    case 'Trip': {
      return TripRecord.fromJS(state);
    }
    case 'TripLeg': {
      return TripLegRecord.fromJS(state);
    }
    case 'TripPassenger': {
      return TripPassengerRecord.fromJS(state);
    }
    case 'UnitActivationRule': {
      return UnitActivationRuleRecord.fromJS(state);
    }
    case 'UnitEMSystemMapping': {
      return UnitEMSystemMappingRecord.fromJS(state);
    }
    case 'Unit': {
      return UnitRecord.fromJS(state);
    }
    case 'UnitNote': {
      return UnitNoteRecord.fromJS(state);
    }
    case 'UnitPosition': {
      return UnitPositionRecord.fromJS(state);
    }
    case 'UnitShift': {
      return UnitShiftRecord.fromJS(state);
    }
    case 'UnitStatusHistoryEntry': {
      return UnitStatusHistoryEntryRecord.fromJS(state);
    }
    case 'UnitSummary': {
      return UnitSummaryRecord.fromJS(state);
    }
    case 'VehicleDisposition': {
      return VehicleDispositionRecord.fromJS(state);
    }
    case 'VehicleNotificationGroup': {
      return VehicleNotificationGroupRecord.fromJS(state);
    }
    case 'VehicleSummary': {
      return VehicleSummaryRecord.fromJS(state);
    }
    case 'Waypoint': {
      return WaypointRecord.fromJS(state);
    }
    case 'WebOrderLog': {
      return WebOrderLogRecord.fromJS(state);
    }
    case 'AccessibleItem': {
      return AccessibleItemRecord.fromJS(state);
    }
    case 'Agency': {
      return AgencyRecord.fromJS(state);
    }
    case 'AgencyLocation': {
      return AgencyLocationRecord.fromJS(state);
    }
    case 'Airport': {
      return AirportRecord.fromJS(state);
    }
    case 'ArchiveLog': {
      return ArchiveLogRecord.fromJS(state);
    }
    case 'Attachment': {
      return AttachmentRecord.fromJS(state);
    }
    case 'BaseControlZone': {
      return BaseControlZoneRecord.fromJS(state);
    }
    case 'Base': {
      return BaseRecord.fromJS(state);
    }
    case 'BaseMedicalControlContact': {
      return BaseMedicalControlContactRecord.fromJS(state);
    }
    case 'BaseMedicalControlContactState': {
      return BaseMedicalControlContactStateRecord.fromJS(state);
    }
    case 'Capability': {
      return CapabilityRecord.fromJS(state);
    }
    case 'CommunicationCenter': {
      return CommunicationCenterRecord.fromJS(state);
    }
    case 'CommunicationCenterTransportOfferOption': {
      return CommunicationCenterTransportOfferOptionRecord.fromJS(state);
    }
    case 'Company': {
      return CompanyRecord.fromJS(state);
    }
    case 'CompleteFlightInstance': {
      return CompleteFlightInstanceRecord.fromJS(state);
    }
    case 'ControlZone': {
      return ControlZoneRecord.fromJS(state);
    }
    case 'Department': {
      return DepartmentRecord.fromJS(state);
    }
    case 'EntityCapability': {
      return EntityCapabilityRecord.fromJS(state);
    }
    case 'ExternalReference': {
      return ExternalReferenceRecord.fromJS(state);
    }
    case 'Fbo': {
      return FboRecord.fromJS(state);
    }
    case 'FuelTank': {
      return FuelTankRecord.fromJS(state);
    }
    case 'Location': {
      return LocationRecord.fromJS(state);
    }
    case 'MaintenanceFacility': {
      return MaintenanceFacilityRecord.fromJS(state);
    }
    case 'MedicalFacilityContact': {
      return MedicalFacilityContactRecord.fromJS(state);
    }
    case 'MedicalFacility': {
      return MedicalFacilityRecord.fromJS(state);
    }
    case 'MedicalFacilityPhysician': {
      return MedicalFacilityPhysicianRecord.fromJS(state);
    }
    case 'MedicalFacilityUnit': {
      return MedicalFacilityUnitRecord.fromJS(state);
    }
    case 'MedicalUnit': {
      return MedicalUnitRecord.fromJS(state);
    }
    case 'OutOfServiceQARReason': {
      return OutOfServiceQARReasonRecord.fromJS(state);
    }
    case 'Person': {
      return PersonRecord.fromJS(state);
    }
    case 'Physician': {
      return PhysicianRecord.fromJS(state);
    }
    case 'ProgramBase': {
      return ProgramBaseRecord.fromJS(state);
    }
    case 'Program': {
      return ProgramRecord.fromJS(state);
    }
    case 'RamcoVehicleConfiguration': {
      return RamcoVehicleConfigurationRecord.fromJS(state);
    }
    case 'RegionBase': {
      return RegionBaseRecord.fromJS(state);
    }
    case 'Region': {
      return RegionRecord.fromJS(state);
    }
    case 'RegionGroup': {
      return RegionGroupRecord.fromJS(state);
    }
    case 'ReleaseNote': {
      return ReleaseNoteRecord.fromJS(state);
    }
    case 'SpecialtyTeam': {
      return SpecialtyTeamRecord.fromJS(state);
    }
    case 'SpecialtyTeamMember': {
      return SpecialtyTeamMemberRecord.fromJS(state);
    }
    case 'State': {
      return StateRecord.fromJS(state);
    }
    case 'SupportRequest': {
      return SupportRequestRecord.fromJS(state);
    }
    case 'Timezone': {
      return TimezoneRecord.fromJS(state);
    }
    case 'TransferCenter': {
      return TransferCenterRecord.fromJS(state);
    }
    case 'TrmUserAgency': {
      return TrmUserAgencyRecord.fromJS(state);
    }
    case 'TrmUser': {
      return TrmUserRecord.fromJS(state);
    }
    case 'TrmUserMedicalFacility': {
      return TrmUserMedicalFacilityRecord.fromJS(state);
    }
    case 'TrmUserProgram': {
      return TrmUserProgramRecord.fromJS(state);
    }
    case 'VehicleControlZone': {
      return VehicleControlZoneRecord.fromJS(state);
    }
    case 'Vehicle': {
      return VehicleRecord.fromJS(state);
    }
    case 'VehicleMaintenance': {
      return VehicleMaintenanceRecord.fromJS(state);
    }
    case 'VehicleMake': {
      return VehicleMakeRecord.fromJS(state);
    }
    case 'VehicleModel': {
      return VehicleModelRecord.fromJS(state);
    }
    case 'VehicleStateInspection': {
      return VehicleStateInspectionRecord.fromJS(state);
    }
    case 'ActiveCardUnitOffering': {
      return ActiveCardUnitOfferingRecord.fromJS(state);
    }
    case 'VehiclePositionSummary': {
      return VehiclePositionSummaryRecord.fromJS(state);
    }
    default:
      return undefined;
  }
}

export function reviveUnsafe({
  state,
  type,
}: {
  state: any;
  type: string;
}): [TcsEntityRecord | undefined, Error[]] {
  switch (type) {
    case 'ActivationRule': {
      return ActivationRuleRecord.fromJSUnsafe(state);
    }
    case 'ActiveAlertAcknowledgement': {
      return ActiveAlertAcknowledgementRecord.fromJSUnsafe(state);
    }
    case 'ActiveAlert': {
      return ActiveAlertRecord.fromJSUnsafe(state);
    }
    case 'ActiveTimeline': {
      return ActiveTimelineRecord.fromJSUnsafe(state);
    }
    case 'Alert': {
      return AlertRecord.fromJSUnsafe(state);
    }
    case 'ApplicationNotification': {
      return ApplicationNotificationRecord.fromJSUnsafe(state);
    }
    case 'AssignmentDelayedReason': {
      return AssignmentDelayedReasonRecord.fromJSUnsafe(state);
    }
    case 'CancellationCategory': {
      return CancellationCategoryRecord.fromJSUnsafe(state);
    }
    case 'CancellationReason': {
      return CancellationReasonRecord.fromJSUnsafe(state);
    }
    case 'CancellationSecondaryReason': {
      return CancellationSecondaryReasonRecord.fromJSUnsafe(state);
    }
    case 'Card': {
      return CardRecord.fromJSUnsafe(state);
    }
    case 'CardLink': {
      return CardLinkRecord.fromJSUnsafe(state);
    }
    case 'CardNoteArchive': {
      return CardNoteArchiveRecord.fromJSUnsafe(state);
    }
    case 'CardNote': {
      return CardNoteRecord.fromJSUnsafe(state);
    }
    case 'CardReOpenReason': {
      return CardReOpenReasonRecord.fromJSUnsafe(state);
    }
    case 'CardSummary': {
      return CardSummaryRecord.fromJSUnsafe(state);
    }
    case 'ConfigurationSetting': {
      return ConfigurationSettingRecord.fromJSUnsafe(state);
    }
    case 'Conversation': {
      return ConversationRecord.fromJSUnsafe(state);
    }
    case 'ConversationParticipant': {
      return ConversationParticipantRecord.fromJSUnsafe(state);
    }
    case 'DeclineCategory': {
      return DeclineCategoryRecord.fromJSUnsafe(state);
    }
    case 'DeclineReason': {
      return DeclineReasonRecord.fromJSUnsafe(state);
    }
    case 'DeclineSecondaryReason': {
      return DeclineSecondaryReasonRecord.fromJSUnsafe(state);
    }
    case 'DiversionReason': {
      return DiversionReasonRecord.fromJSUnsafe(state);
    }
    case 'EscortRequest': {
      return EscortRequestRecord.fromJSUnsafe(state);
    }
    case 'EstimatedDuration': {
      return EstimatedDurationRecord.fromJSUnsafe(state);
    }
    case 'Eta': {
      return EtaRecord.fromJSUnsafe(state);
    }
    case 'ExternalAction': {
      return ExternalActionRecord.fromJSUnsafe(state);
    }
    case 'ExternalActionType': {
      return ExternalActionTypeRecord.fromJSUnsafe(state);
    }
    case 'ExternalSystemUnit': {
      return ExternalSystemUnitRecord.fromJSUnsafe(state);
    }
    case 'FacilityNonAcceptanceReason': {
      return FacilityNonAcceptanceReasonRecord.fromJSUnsafe(state);
    }
    case 'FirewallRule': {
      return FirewallRuleRecord.fromJSUnsafe(state);
    }
    case 'FlightFollowingReport': {
      return FlightFollowingReportRecord.fromJSUnsafe(state);
    }
    case 'LandingZoneOutOfServiceReason': {
      return LandingZoneOutOfServiceReasonRecord.fromJSUnsafe(state);
    }
    case 'LocationHazardAttachment': {
      return LocationHazardAttachmentRecord.fromJSUnsafe(state);
    }
    case 'LocationHazard': {
      return LocationHazardRecord.fromJSUnsafe(state);
    }
    case 'ManifestEntry': {
      return ManifestEntryRecord.fromJSUnsafe(state);
    }
    case 'MedicalControlContactLogEntry': {
      return MedicalControlContactLogEntryRecord.fromJSUnsafe(state);
    }
    case 'MessageStatusUpdate': {
      return MessageStatusUpdateRecord.fromJSUnsafe(state);
    }
    case 'NewAgencyLocationRequest': {
      return NewAgencyLocationRequestRecord.fromJSUnsafe(state);
    }
    case 'NextDueType': {
      return NextDueTypeRecord.fromJSUnsafe(state);
    }
    case 'NonReferralReason': {
      return NonReferralReasonRecord.fromJSUnsafe(state);
    }
    case 'Notification': {
      return NotificationRecord.fromJSUnsafe(state);
    }
    case 'NotificationGroup': {
      return NotificationGroupRecord.fromJSUnsafe(state);
    }
    case 'NotificationGroupMember': {
      return NotificationGroupMemberRecord.fromJSUnsafe(state);
    }
    case 'NotificationRecipient': {
      return NotificationRecipientRecord.fromJSUnsafe(state);
    }
    case 'NotificationSubscription': {
      return NotificationSubscriptionRecord.fromJSUnsafe(state);
    }
    case 'NotificationTemplate': {
      return NotificationTemplateRecord.fromJSUnsafe(state);
    }
    case 'OemActivity': {
      return OemActivityRecord.fromJSUnsafe(state);
    }
    case 'OemAsset': {
      return OemAssetRecord.fromJSUnsafe(state);
    }
    case 'OemPlanChangeRequest': {
      return OemPlanChangeRequestRecord.fromJSUnsafe(state);
    }
    case 'OemPlan': {
      return OemPlanRecord.fromJSUnsafe(state);
    }
    case 'OfferAlgorithm': {
      return OfferAlgorithmRecord.fromJSUnsafe(state);
    }
    case 'Operation': {
      return OperationRecord.fromJSUnsafe(state);
    }
    case 'OutOfServiceEvent': {
      return OutOfServiceEventRecord.fromJSUnsafe(state);
    }
    case 'OutOfServiceEventNote': {
      return OutOfServiceEventNoteRecord.fromJSUnsafe(state);
    }
    case 'OutOfServiceReason': {
      return OutOfServiceReasonRecord.fromJSUnsafe(state);
    }
    case 'OutOfServiceSecondaryReason': {
      return OutOfServiceSecondaryReasonRecord.fromJSUnsafe(state);
    }
    case 'OutOfServiceTicket': {
      return OutOfServiceTicketRecord.fromJSUnsafe(state);
    }
    case 'PaipEvent': {
      return PaipEventRecord.fromJSUnsafe(state);
    }
    case 'PaipReason': {
      return PaipReasonRecord.fromJSUnsafe(state);
    }
    case 'PassdownLogAcknowledgement': {
      return PassdownLogAcknowledgementRecord.fromJSUnsafe(state);
    }
    case 'PassdownLogArchivedLog': {
      return PassdownLogArchivedLogRecord.fromJSUnsafe(state);
    }
    case 'PassdownLog': {
      return PassdownLogRecord.fromJSUnsafe(state);
    }
    case 'Patient': {
      return PatientRecord.fromJSUnsafe(state);
    }
    case 'PositionReportAlert': {
      return PositionReportAlertRecord.fromJSUnsafe(state);
    }
    case 'PositionReportArchive': {
      return PositionReportArchiveRecord.fromJSUnsafe(state);
    }
    case 'PositionReport': {
      return PositionReportRecord.fromJSUnsafe(state);
    }
    case 'QuestionChoice': {
      return QuestionChoiceRecord.fromJSUnsafe(state);
    }
    case 'Question': {
      return QuestionRecord.fromJSUnsafe(state);
    }
    case 'Questionnaire': {
      return QuestionnaireRecord.fromJSUnsafe(state);
    }
    case 'QuestionnaireQuestionResponse': {
      return QuestionnaireQuestionResponseRecord.fromJSUnsafe(state);
    }
    case 'QuestionnaireQuestionResponseNote': {
      return QuestionnaireQuestionResponseNoteRecord.fromJSUnsafe(state);
    }
    case 'QuestionnaireResponse': {
      return QuestionnaireResponseRecord.fromJSUnsafe(state);
    }
    case 'QuestionnaireSection': {
      return QuestionnaireSectionRecord.fromJSUnsafe(state);
    }
    case 'QuestionnaireSectionQuestion': {
      return QuestionnaireSectionQuestionRecord.fromJSUnsafe(state);
    }
    case 'ReceivingFacilityRequest': {
      return ReceivingFacilityRequestRecord.fromJSUnsafe(state);
    }
    case 'RendezvousRequest': {
      return RendezvousRequestRecord.fromJSUnsafe(state);
    }
    case 'Request': {
      return RequestRecord.fromJSUnsafe(state);
    }
    case 'Requester': {
      return RequesterRecord.fromJSUnsafe(state);
    }
    case 'RequesterReferralReason': {
      return RequesterReferralReasonRecord.fromJSUnsafe(state);
    }
    case 'RequesterRole': {
      return RequesterRoleRecord.fromJSUnsafe(state);
    }
    case 'RequestLocation': {
      return RequestLocationRecord.fromJSUnsafe(state);
    }
    case 'RequestPatient': {
      return RequestPatientRecord.fromJSUnsafe(state);
    }
    case 'SystemTimer': {
      return SystemTimerRecord.fromJSUnsafe(state);
    }
    case 'Timeline': {
      return TimelineRecord.fromJSUnsafe(state);
    }
    case 'TimelineItem': {
      return TimelineItemRecord.fromJSUnsafe(state);
    }
    case 'Timestamp': {
      return TimestampRecord.fromJSUnsafe(state);
    }
    case 'TimestampType': {
      return TimestampTypeRecord.fromJSUnsafe(state);
    }
    case 'TrackedMessage': {
      return TrackedMessageRecord.fromJSUnsafe(state);
    }
    case 'TransferReason': {
      return TransferReasonRecord.fromJSUnsafe(state);
    }
    case 'TransportOffer': {
      return TransportOfferRecord.fromJSUnsafe(state);
    }
    case 'TransportOfferOption': {
      return TransportOfferOptionRecord.fromJSUnsafe(state);
    }
    case 'TransportReason': {
      return TransportReasonRecord.fromJSUnsafe(state);
    }
    case 'Trip': {
      return TripRecord.fromJSUnsafe(state);
    }
    case 'TripLeg': {
      return TripLegRecord.fromJSUnsafe(state);
    }
    case 'TripPassenger': {
      return TripPassengerRecord.fromJSUnsafe(state);
    }
    case 'UnitActivationRule': {
      return UnitActivationRuleRecord.fromJSUnsafe(state);
    }
    case 'UnitEMSystemMapping': {
      return UnitEMSystemMappingRecord.fromJSUnsafe(state);
    }
    case 'Unit': {
      return UnitRecord.fromJSUnsafe(state);
    }
    case 'UnitNote': {
      return UnitNoteRecord.fromJSUnsafe(state);
    }
    case 'UnitPosition': {
      return UnitPositionRecord.fromJSUnsafe(state);
    }
    case 'UnitShift': {
      return UnitShiftRecord.fromJSUnsafe(state);
    }
    case 'UnitStatusHistoryEntry': {
      return UnitStatusHistoryEntryRecord.fromJSUnsafe(state);
    }
    case 'UnitSummary': {
      return UnitSummaryRecord.fromJSUnsafe(state);
    }
    case 'VehicleDisposition': {
      return VehicleDispositionRecord.fromJSUnsafe(state);
    }
    case 'VehicleNotificationGroup': {
      return VehicleNotificationGroupRecord.fromJSUnsafe(state);
    }
    case 'VehicleSummary': {
      return VehicleSummaryRecord.fromJSUnsafe(state);
    }
    case 'Waypoint': {
      return WaypointRecord.fromJSUnsafe(state);
    }
    case 'WebOrderLog': {
      return WebOrderLogRecord.fromJSUnsafe(state);
    }
    case 'AccessibleItem': {
      return AccessibleItemRecord.fromJSUnsafe(state);
    }
    case 'Agency': {
      return AgencyRecord.fromJSUnsafe(state);
    }
    case 'AgencyLocation': {
      return AgencyLocationRecord.fromJSUnsafe(state);
    }
    case 'Airport': {
      return AirportRecord.fromJSUnsafe(state);
    }
    case 'ArchiveLog': {
      return ArchiveLogRecord.fromJSUnsafe(state);
    }
    case 'Attachment': {
      return AttachmentRecord.fromJSUnsafe(state);
    }
    case 'BaseControlZone': {
      return BaseControlZoneRecord.fromJSUnsafe(state);
    }
    case 'Base': {
      return BaseRecord.fromJSUnsafe(state);
    }
    case 'BaseMedicalControlContact': {
      return BaseMedicalControlContactRecord.fromJSUnsafe(state);
    }
    case 'BaseMedicalControlContactState': {
      return BaseMedicalControlContactStateRecord.fromJSUnsafe(state);
    }
    case 'Capability': {
      return CapabilityRecord.fromJSUnsafe(state);
    }
    case 'CommunicationCenter': {
      return CommunicationCenterRecord.fromJSUnsafe(state);
    }
    case 'CommunicationCenterTransportOfferOption': {
      return CommunicationCenterTransportOfferOptionRecord.fromJSUnsafe(state);
    }
    case 'Company': {
      return CompanyRecord.fromJSUnsafe(state);
    }
    case 'CompleteFlightInstance': {
      return CompleteFlightInstanceRecord.fromJSUnsafe(state);
    }
    case 'ControlZone': {
      return ControlZoneRecord.fromJSUnsafe(state);
    }
    case 'Department': {
      return DepartmentRecord.fromJSUnsafe(state);
    }
    case 'EntityCapability': {
      return EntityCapabilityRecord.fromJSUnsafe(state);
    }
    case 'ExternalReference': {
      return ExternalReferenceRecord.fromJSUnsafe(state);
    }
    case 'Fbo': {
      return FboRecord.fromJSUnsafe(state);
    }
    case 'FuelTank': {
      return FuelTankRecord.fromJSUnsafe(state);
    }
    case 'Location': {
      return LocationRecord.fromJSUnsafe(state);
    }
    case 'MaintenanceFacility': {
      return MaintenanceFacilityRecord.fromJSUnsafe(state);
    }
    case 'MedicalFacilityContact': {
      return MedicalFacilityContactRecord.fromJSUnsafe(state);
    }
    case 'MedicalFacility': {
      return MedicalFacilityRecord.fromJSUnsafe(state);
    }
    case 'MedicalFacilityPhysician': {
      return MedicalFacilityPhysicianRecord.fromJSUnsafe(state);
    }
    case 'MedicalFacilityUnit': {
      return MedicalFacilityUnitRecord.fromJSUnsafe(state);
    }
    case 'MedicalUnit': {
      return MedicalUnitRecord.fromJSUnsafe(state);
    }
    case 'OutOfServiceQARReason': {
      return OutOfServiceQARReasonRecord.fromJSUnsafe(state);
    }
    case 'Person': {
      return PersonRecord.fromJSUnsafe(state);
    }
    case 'Physician': {
      return PhysicianRecord.fromJSUnsafe(state);
    }
    case 'ProgramBase': {
      return ProgramBaseRecord.fromJSUnsafe(state);
    }
    case 'Program': {
      return ProgramRecord.fromJSUnsafe(state);
    }
    case 'RamcoVehicleConfiguration': {
      return RamcoVehicleConfigurationRecord.fromJSUnsafe(state);
    }
    case 'RegionBase': {
      return RegionBaseRecord.fromJSUnsafe(state);
    }
    case 'Region': {
      return RegionRecord.fromJSUnsafe(state);
    }
    case 'RegionGroup': {
      return RegionGroupRecord.fromJSUnsafe(state);
    }
    case 'ReleaseNote': {
      return ReleaseNoteRecord.fromJSUnsafe(state);
    }
    case 'SpecialtyTeam': {
      return SpecialtyTeamRecord.fromJSUnsafe(state);
    }
    case 'SpecialtyTeamMember': {
      return SpecialtyTeamMemberRecord.fromJSUnsafe(state);
    }
    case 'State': {
      return StateRecord.fromJSUnsafe(state);
    }
    case 'SupportRequest': {
      return SupportRequestRecord.fromJSUnsafe(state);
    }
    case 'Timezone': {
      return TimezoneRecord.fromJSUnsafe(state);
    }
    case 'TransferCenter': {
      return TransferCenterRecord.fromJSUnsafe(state);
    }
    case 'TrmUserAgency': {
      return TrmUserAgencyRecord.fromJSUnsafe(state);
    }
    case 'TrmUser': {
      return TrmUserRecord.fromJSUnsafe(state);
    }
    case 'TrmUserMedicalFacility': {
      return TrmUserMedicalFacilityRecord.fromJSUnsafe(state);
    }
    case 'TrmUserProgram': {
      return TrmUserProgramRecord.fromJSUnsafe(state);
    }
    case 'VehicleControlZone': {
      return VehicleControlZoneRecord.fromJSUnsafe(state);
    }
    case 'Vehicle': {
      return VehicleRecord.fromJSUnsafe(state);
    }
    case 'VehicleMaintenance': {
      return VehicleMaintenanceRecord.fromJSUnsafe(state);
    }
    case 'VehicleMake': {
      return VehicleMakeRecord.fromJSUnsafe(state);
    }
    case 'VehicleModel': {
      return VehicleModelRecord.fromJSUnsafe(state);
    }
    case 'VehicleStateInspection': {
      return VehicleStateInspectionRecord.fromJSUnsafe(state);
    }
    case 'ActiveCardUnitOffering': {
      return ActiveCardUnitOfferingRecord.fromJSUnsafe(state);
    }
    case 'VehiclePositionSummary': {
      return VehiclePositionSummaryRecord.fromJSUnsafe(state);
    }
    default:
      return [undefined, [new Error(`Unable to find revive record of type '${type}'`)]];
  }
}
